import { render, staticRenderFns } from "./GameSelection.vue?vue&type=template&id=05de166a&scoped=true"
import script from "./GameSelection.vue?vue&type=script&lang=js"
export * from "./GameSelection.vue?vue&type=script&lang=js"
import style0 from "./GameSelection.vue?vue&type=style&index=0&id=05de166a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05de166a",
  null
  
)

export default component.exports